import firebase from 'firebase'

//Satia
// var firebaseConfig = {
//     apiKey: "AIzaSyDqX1labatJBlnnHNgmO0R3kngZOsXTTwU",
//     authDomain: "satiaapp.firebaseapp.com",
//     databaseURL: "https://satiaapp.firebaseio.com",
//     projectId: "satiaapp",
//     storageBucket: "satiaapp.appspot.com",
//     messagingSenderId: "1026712654485",
//     appId: "1:1026712654485:web:160c851231b8b6e1d1c19c",
//     measurementId: "G-ES9XHPDEMC"
// };

//Arak
// var firebaseConfig = {
// apiKey: "AIzaSyARXzo_jgpX_1KdjaDwX1ZKl1wQdYzabSI",
//     authDomain: "arak-man.firebaseapp.com",
//     databaseURL: "https://arak-man.firebaseio.com",
//     projectId: "arak-man",
//     storageBucket: "arak-man.appspot.com",
//     messagingSenderId: "99933604098",
//     appId: "1:99933604098:web:1642134807a8d24eabda1b",
//     measurementId: "G-YZ8PPQ27C3"
// };

//Ahvaz
// var firebaseConfig = {
// apiKey: "AIzaSyAdb6BdPqTkkckx_edqCCWEb8wF9Ml5QNs",
//     authDomain: "ahvazman-97805.firebaseapp.com",
//     databaseURL: "https://ahvazman-97805.firebaseio.com",
//     projectId: "ahvazman-97805",
//     storageBucket: "ahvazman-97805.appspot.com",
//     messagingSenderId: "102075591755",
//     appId: "1:102075591755:web:fcb629b955069ea49431ce",
//     measurementId: "G-915KW01MSK"
// };

//Borazjan
// var firebaseConfig = {
// apiKey: "AIzaSyCans6x3Qh6495YTFpluS5ZMPMcDGj9trw",
//     authDomain: "borazjan-b568e.firebaseapp.com",
//     projectId: "borazjan-b568e",
//     storageBucket: "borazjan-b568e.appspot.com",
//     messagingSenderId: "1064152208075",
//     appId: "1:1064152208075:web:e8b54948a8c4a2e109c14e",
//     measurementId: "G-22DPZLEDP2"
// };

//Roudan
// var firebaseConfig = {
// apiKey: "AIzaSyBPs7MTV25tpRKzrExqtQjXx33-pP7YyKg",
//     authDomain: "roudan-7d256.firebaseapp.com",
//     projectId: "roudan-7d256",
//     storageBucket: "roudan-7d256.appspot.com",
//     messagingSenderId: "682259956977",
//     appId: "1:682259956977:web:e4b29f3972324854815550",
//     measurementId: "G-BFFNQ2XNNB"
// };

//Maraghe
// const firebaseConfig = {
//     apiKey: "AIzaSyASqTt6WKxH6MxmXFOodQQqqnacRApicT4",
//     authDomain: "maraghe137.firebaseapp.com",
//     projectId: "maraghe137",
//     storageBucket: "maraghe137.appspot.com",
//     messagingSenderId: "163860639209",
//     appId: "1:163860639209:web:0a042436915905f2296f78",
//     measurementId: "G-FBJ282XZYZ"
// };

//Khorramshahr
// const firebaseConfig = {
//     apiKey: "AIzaSyBNxPeXNLfcacH6kr0aQSkZKkqtOZQuRZM",
//     authDomain: "khorramshahr-231d2.firebaseapp.com",
//     projectId: "khorramshahr-231d2",
//     storageBucket: "khorramshahr-231d2.appspot.com",
//     messagingSenderId: "184017798094",
//     appId: "1:184017798094:web:bd7a3659c276d262eb619f",
//     measurementId: "G-21VVC8N0PY"
// };

//bushehr
// const firebaseConfig = {
//     apiKey: "AIzaSyAD3HbGhgaS6GFPRF2Mt1TeVRMwjahuIHE",
//     authDomain: "bushehr-667c1.firebaseapp.com",
//     projectId: "bushehr-667c1",
//     storageBucket: "bushehr-667c1.appspot.com",
//     messagingSenderId: "228784635580",
//     appId: "1:228784635580:web:e97bfa3db6f130254d5ab9",
//     measurementId: "G-M9LRQ64WS5"
// };

//Gerash
// const firebaseConfig = {
//     apiKey: "AIzaSyDeRzSP2N_Km2Kn5XqliAzI8v30cQCaPj8",
//     authDomain: "gerash-c5793.firebaseapp.com",
//     projectId: "gerash-c5793",
//     storageBucket: "gerash-c5793.appspot.com",
//     messagingSenderId: "594655606811",
//     appId: "1:594655606811:web:0e6b002fb114c27111a0be",
//     measurementId: "G-S5WQT2B32S"
// };

//Behbahan
// const firebaseConfig = {
//     apiKey: "AIzaSyBT5OOzVdDrhP8wOwMUVaq2jt1XJsF7scw",
//     authDomain: "behbahan-ba715.firebaseapp.com",
//     projectId: "behbahan-ba715",
//     storageBucket: "behbahan-ba715.appspot.com",
//     messagingSenderId: "642814599308",
//     appId: "1:642814599308:web:2ccc5d77fa0d429a4cdba9",
//     measurementId: "G-E5J5C31F1M"
// };

//Shahrman
// const firebaseConfig = {
//     apiKey: "AIzaSyA1SiSSovkeU07GwLugPC6lb2QZNpPNGQs",
//     authDomain: "shahrman137.firebaseapp.com",
//     projectId: "shahrman137",
//     storageBucket: "shahrman137.appspot.com",
//     messagingSenderId: "805615981499",
//     appId: "1:805615981499:web:d2f1f3c40e68fdb6bb2a9e",
//     measurementId: "G-R705561FVW"
// };


//Cloud
const firebaseConfig = {
    apiKey: "AIzaSyDcAreTq7qqlIb9gxr_EWoLKsnajN1mLjo",
    authDomain: "cloud137-c5511.firebaseapp.com",
    projectId: "cloud137-c5511",
    storageBucket: "cloud137-c5511.appspot.com",
    messagingSenderId: "291839198610",
    appId: "1:291839198610:web:54bb3467bb3515cbba6d4b",
    measurementId: "G-QPL9X8XVEZ"
};


// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export default firebase
